import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { apwRetry } from './retry';
import { getClient } from './gqlClient';
import { getError } from './GqlError';
export { wrapQuery };
function wrapQuery(_x, _x2, _x3) {
  return _wrapQuery.apply(this, arguments);
}
function _wrapQuery() {
  _wrapQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(api, query, variables) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return apwRetry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return getClient().request(query, variables);
                case 3:
                  return _context.abrupt("return", _context.sent);
                case 6:
                  _context.prev = 6;
                  _context.t0 = _context["catch"](0);
                  _context.t0.apiName = api;
                  throw getError(_context.t0);
                case 10:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 6]]);
          })));
        case 2:
          return _context2.abrupt("return", _context2.sent);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _wrapQuery.apply(this, arguments);
}